import React from 'react';
import '../styles/Home.css';

function Home() {
  return (
    <div className="home-container">
      <div className="top-section">

          <img src="/assets/logo.png" alt="EMC Logo" className="home-logo" />
      </div>

      
    </div>
  );
}

export default Home;